/* Roar 4x4 - Wholesale/VIP Auto-Discount */
(function(){
  var tierCode = window.__roarTierCode || '';
  if (!tierCode) return;

  // Auto-apply discount code when items are added to cart
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (form.action && form.action.indexOf('/cart/add') > -1) {
      // After add-to-cart, apply the discount
      setTimeout(function() {
        fetch('/discount/' + tierCode, { method: 'GET', redirect: 'follow' })
          .then(function(){ console.log('Roar: Discount ' + tierCode + ' applied'); })
          .catch(function(err){ console.log('Roar: Discount error', err); });
      }, 500);
    }
  });

  // Also apply on page load if cart has items
  fetch('/cart.json')
    .then(function(r){ return r.json(); })
    .then(function(cart){
      if (cart.item_count > 0) {
        fetch('/discount/' + tierCode, { method: 'GET', redirect: 'follow' });
      }
    });
})();
